import styles from './BarStyles.module.css'
import React from 'react'
const BarLoader = () => {
  return (
    <div className={styles.loader_container}>
      <div className={styles.loader} />
    </div>
  )
}

export default BarLoader